import React from 'react'
import '../styles/style.css'
import back from '../images/back.svg'
import zumba from '../images/zumba.svg'
import { getContentHeaders, getGetApi,registerPlayerCount } from '../common/axiosConfig';
import apiUrls from '../common/apiUrls';
import { FRONT_END_NAME } from '../common/constants';
import Loader from '../common/loader'

class Zumba extends React.Component {

    constructor(props)
        {
            super(props);
            //debugger;
            var categoryDetails = props.location.state;
            if(!categoryDetails){
                categoryDetails = {
                    categoryId : "",
                    categoryName : ""
                }
            }
            this.state = {
                subCategories : [],
                subCategoriesElems : [],
                categoryName : categoryDetails.categoryName,
                categoryId : categoryDetails.categoryId,
                recentVideos : [],
                showLoader : false

                
            }
        }

        showLoader = () =>{
            this.setState({showLoader:true});
        }
        hideLoader = () =>{
            this.setState({showLoader:false});
        }

        getSubCategoryList = () =>{
            //debugger;
            this.showLoader();
            var url = apiUrls.subcat;
            url = url.replace("<categoryId>",this.state.categoryId);
            getGetApi(url,getContentHeaders()).then((response)=>{
                //debugger;
                if(response.data.code == 2000){
                    
                   
                    //var subCategories = [];
                    var subCategories = response.data.data.categories[0].subCategories.filter((subCat)=>{return subCat.description != "bottom"})
                    if(subCategories.length == 1){
                        sessionStorage["toSub"] = false;
                        this.fetchVideos(subCategories[0]);
                    }
                    else {
                        sessionStorage["toSub"] = true;
                        this.hideLoader();
                    // subCategoriesList.forEach(element => {
                    //   subCategories.push({
                    //       title:element.title,
                    //       previewImageUrl: element.previewImageUrl
                    //   })
                    // });
                  this.setState({subCategories});
                  
                  var recentVideos = response.data.data.categories[0].subCategories.filter((subCat)=>{return subCat.description == "bottom"});
                  //debugger;
                  if(recentVideos[0]){
                      this.setState({recentVideos:recentVideos[0].content3});
                  }
                }
                }
            })
        }

        fetchVideos = (subCategory) =>{
            debugger;
            //registerPlayerCount()
            console.log("subcategory",subCategory);
            localStorage[subCategory.title] = JSON.stringify(subCategory.content3);
            this.props.history.push({pathname:FRONT_END_NAME+"/videos",state:{title:subCategory.title}});
        }

        componentDidMount (){
            this.getSubCategoryList();
        }

        goBack = () =>{
            this.props.history.goBack()
        }

        playVideo = (item) =>{
            this.props.history.push({pathname:FRONT_END_NAME+"/videoplay",state:{video:item}})
        }

        getSubCategoryListComp(){
            var subCategoriesElems = [];

            for( let i=0;i<this.state.subCategories.length;i++){
                let first =i;
                let second = ++i;
                let third = ++i;
                var comp = <div className="overallEx" key={i}>
                    {this.state.subCategories[first] && <div className="ex-item" onClick={() => { this.fetchVideos(this.state.subCategories[first]) }}>
                        <img src={this.state.subCategories[first].previewImageUrl}></img>
                        <p className="wd-60">{this.state.subCategories[first].title}</p>
                    </div>}
                    {this.state.subCategories[second] && <div className="ex-item" onClick={() => { this.fetchVideos(this.state.subCategories[second]) }}>
                        <img src={this.state.subCategories[second].previewImageUrl}></img>
                        <p className="wd-60">{this.state.subCategories[second].title}</p>
                    </div>}
                    {this.state.subCategories[third] && <div className="ex-item" onClick={() => { this.fetchVideos(this.state.subCategories[third]) }}>
                        <img src={this.state.subCategories[third].previewImageUrl}></img>
                        <p className="wd-60">{this.state.subCategories[third].title}</p>
                    </div>}
                </div>
             subCategoriesElems.push(comp);
            }
            return subCategoriesElems;// this.setState({subCategoriesElems});


        }

    render() {

        let {subCategories} = this.state;

        return (
            <div className="container-ex">
                {this.state.showLoader && <Loader></Loader>}
                <div className="header-ex">
                    <img src={back} onClick={this.goBack}></img>
                    <p>{this.state.categoryName}</p>
                </div>
                <div className="content-ex">
                    {/* <div className="overallEx">
                        <div className="ex-item">
                            <img src={zumba}></img>
                            <p className="wd-60">Zumba</p>
                        </div>
                        <div className="ex-item">
                            <img src={zumba}></img>
                            <p className="wd-60">Zumba</p>
                        </div>
                        <div className="ex-item">
                            <img src={zumba}></img>
                            <p className="wd-60">Zumba</p>
                        </div>
                    </div> */}

                    {this.getSubCategoryListComp()}
                   

                    {/* {
                      subCategories.map((subCategory,index)=>
                        <div className="ex-item" key={index} onClick={()=>{this.fetchVideos(subCategory)}}>
                            <img src={subCategory.previewImageUrl}></img>
                            <p className="wd-60">{subCategory.title}</p>
                        </div>
                    )} */}
                    
                </div>
                <div className="recent mg-zumba">
                    <div className="recent-p">
                        <span>TOP VIDEOS</span>
                        {/* <span>See All</span> */}
                    </div>
                    <div className="recent-list">
                        {this.state.recentVideos.map((recent,index)=>
                        <div>
                            <div className="recent-list-div" key={index} style={{backgroundImage:`url(${recent.videoPreviewImage})`}} onClick={()=>{this.playVideo(recent)}}>
                            </div>                           
                            <p className="data-home-n">{recent.title}</p>
                        </div>    
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default Zumba;